import type { ComponentType } from "react";
import {
  IconArrowLeft,
  IconCalendarEvent,
  IconChevronDown,
  IconCopy,
  IconDownload,
  IconEdit,
  IconEye,
  IconFilter,
  IconMail,
  IconPlus,
  IconPhoto,
  IconRefresh,
  IconSearch,
  IconSettings,
  IconSparkles,
  IconTable,
  IconTrash,
  IconUpload,
  IconX,
} from "@tabler/icons-react";

export type IconName =
  | "arrow-left"
  | "calendar"
  | "chevron-down"
  | "copy"
  | "download"
  | "edit"
  | "eye"
  | "filter"
  | "image"
  | "mail"
  | "plus"
  | "refresh"
  | "search"
  | "settings"
  | "spark"
  | "table"
  | "trash"
  | "upload"
  | "x";

type IconComponentProps = {
  className?: string;
  size?: string | number;
  stroke?: string | number;
  "aria-hidden"?: boolean;
};

const ICONS: Record<IconName, ComponentType<IconComponentProps>> = {
  "arrow-left": IconArrowLeft,
  calendar: IconCalendarEvent,
  "chevron-down": IconChevronDown,
  copy: IconCopy,
  download: IconDownload,
  edit: IconEdit,
  eye: IconEye,
  filter: IconFilter,
  image: IconPhoto,
  mail: IconMail,
  plus: IconPlus,
  refresh: IconRefresh,
  search: IconSearch,
  settings: IconSettings,
  spark: IconSparkles,
  table: IconTable,
  trash: IconTrash,
  upload: IconUpload,
  x: IconX,
};

export function Icon({
  name,
  className = "ui-icon",
  size = "1em",
  stroke = 1.9,
}: {
  name: IconName;
  className?: string;
  size?: string | number;
  stroke?: string | number;
}) {
  const Component = ICONS[name];
  return <Component className={className} size={size} stroke={stroke} aria-hidden={true} />;
}

export function IconLabel({
  icon,
  label,
}: {
  icon: IconName;
  label: string;
}) {
  return (
    <span className="icon-label">
      <Icon name={icon} />
      <span>{label}</span>
    </span>
  );
}
